import { all } from "redux-saga/effects";
import { watchGetListData } from "./listdata";
import { watchGetDetailData } from "./detaildata";
import { watchGetFormPost } from "./formpost";
import { watchGetEmpListData } from "./emplistdata";
import { watchGetEmpDetailData } from "./empdetaildata";
import { watchGetEmpFormPost } from "./empformpost";

export default function* rootSaga() {
  yield all([
    watchGetListData(),
    watchGetDetailData(),
    watchGetFormPost(),
    watchGetEmpListData(),
    watchGetEmpDetailData(),
    watchGetEmpFormPost(),
  ]);
}
